:host {
  display: block;
  max-width: 100%;
  padding: 64px 0 16px 16px;
  overflow: hidden;

  --label-width-percentage: 40%;
  --value-width-percentage: 60%;
  --padding-value: calc(var(--spacer) * 3);
}

gz-labeled-content {
  height: auto;

  &::part(content) {
    margin-top: -2px;
  }

  &::part(label) {
    color: var(--chart-300-icon-buttons);
    text-transform: uppercase;
  }
}

.subtitle-value {
  color: var(--chart-300-icon-buttons);
  text-transform: uppercase;
}

.content {
  height: calc(100% - 86px);
  overflow-x: hidden;
  overflow-y: scroll;
  padding-right: calc(var(--spacer) - 2px);
}

.container-mitre {
  height: 26px;

  .label {
    width: var(--label-width-percentage);
  }

  .value {
    width: var(--value-width-percentage);
    padding-left: var(--padding-value);
  }
}
